<template>
  <el-row class="roleManage">
      <el-row class="table">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>工单分配设置</span>
                  <div>
                    <el-button  type="primary" @click="addEvent">新增</el-button>
                  </div>
                </div>
                <div class="text item">
                  <el-table
                    :data="tableData"
                    style="width: 100%">
                    <el-table-column
                      fixed
                      prop="category_name"
                      label="亿价通一级分类">
                    </el-table-column>
                    <el-table-column
                      prop="role_name"
                      label="对应钉钉后台分组">
                    </el-table-column>
                    <el-table-column
                      fixed="right"
                      label="操作"
                      width="150">
                      <template slot-scope="scope">
                        <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="delateEvent(scope.row)" type="text" size="small">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="pages">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    @current-change="currentClick">
                  </el-pagination>
                </div>
          </el-card>
      </el-row>
      <el-dialog title="新增/修改工单分配设置" :visible.sync="dialogFormVisible">
        <el-form :model="dialogForm">
          <el-form-item label="钉钉后台对应分组" :label-width="formLabelWidth">
            <el-select clearable v-model="dialogForm.role_id" placeholder="请选择活动区域" @change="categoryChange">
              <el-option  v-for="item in roleArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="亿价通一级分类" :label-width="formLabelWidth">
            <el-select v-model="dialogForm.category_id" multiple placeholder="请选择" @change="departChange" ref="depart">
              <el-option  v-for="item in departArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogCancel">取 消</el-button>
          <el-button type="primary" @click="dialogCommit" v-if="btnShow">确 定</el-button>
          <el-button type="primary" @click="edit" v-if="!btnShow">确定</el-button>
        </div>
      </el-dialog>
  </el-row>
</template>

<script>
import { conversionTable,getRole,departTable,conversionTables,conversionInsert,conversionEdit,conversionRemove } from '../../utils/api'
export default {
components: {},
props: {},
data() {
  return {
    total:0,
    rowId:0,
    btnShow:true,
    dialogFormVisible:false,
    formLabelWidth: '150px',
    tableData:[],
    page:1,
    pageSize:5,
    dialogForm:{
      role_id:'',     //角色id
      role_name:'',   //角色名称
      category_id:[],   //部门id
      category_name:[]  //部门名称
    },
    departArr:[],
    roleArr:[],
  };
},
watch: {
  dialogFormVisible(value){
    if(value == false){
      this.dialogForm.role_id = '';
      this.dialogForm.role_name = '';
      this.dialogForm.category_id = [];
      this.dialogForm.category_name = []
    }
  }
},
computed: {},
methods: {
  //新增
  addEvent(){
    this.dialogFormVisible = true
    this.btnShow = true
  },
  // 编辑
  editClick(row){
    console.log(row,'row');
    this.dialogFormVisible = true
    this.btnShow = false
    var that = this
    that.rowId = row.id
    that.dialogForm.category_id = JSON.parse(row.category_id)
    that.dialogForm.category_name = JSON.parse(row.category_name)
    that.dialogForm.role_id = row.role_id
    that.dialogForm.role_name = row.role_name
  },
  //编辑确认
  edit(){
    var that = this
    var params = {
      id:that.rowId,
      role_id:that.dialogForm.role_id,
      role_name:that.dialogForm.role_name,
      category_id:JSON.stringify(that.dialogForm.category_id),
      category_name:JSON.stringify(that.dialogForm.category_name)
    }
    conversionEdit(params)
    .then(res=>{
      console.log(res,'res');
      if(res.message.status == 'success'){
        that.dialogFormVisible = false
        that.getconversionTable()
        that.$message.success('成功')
      }else{
        that.$message.error('失败')
      }
    })
    .catch(err=>{
      console.log(err,'err');
    })
  },
  //删除
  delateEvent(row){
    var that = this
    var params = {
      id : row.id
    }
    conversionRemove(params)
    .then(res=>{
      console.log(res,'res');
      if(res.message.status == 'success'){
        that.$message.success(res.message.text)
        that.getconversionTable()
      }else{
        that.$message.error(res.message.text)
      }
    })
    .catch(err=>{
      console.log(err,'err');
    })
    console.log(row,'删除');
  },
  //弹窗新增提交
  dialogCommit(){
    console.log('弹窗提交');
    this.dialogFormVisible = false
  },
  dialogCancel(){
    console.log('弹窗取消');
    this.dialogFormVisible = false
  },
  currentClick(e){
    this.page = e
    this.getconversionTable()
    console.log('dnagqianusns');
  },
  //分配协议列表
  getconversionTable(){
    var that = this
    var params = {
      page:that.page,
      pagesize:that.pageSize
    }
    conversionTables(params)
    .then(res=>{
      console.log(res,'分配协议列表');
      if(res.message.status == 'success'){
          that.tableData = res.data
          that.total = res.total
      }else{
        that.tableData = []
      }
    })
    .catch(err=>{
      console.log(err,'err');
    })
  },
  //获取钉钉角色列表
  getRoleTable(){
    var that = this
    getRole()
    .then(res=>{
        if(res.message.status == 'success'){
            console.log(res,'角色列表');
            if(res.message.status == 'success'){
              that.roleArr = res.data
            }else{
              that.$message.error(res.message.text)
            }
        }
    })
    .catch(err=>{
        console.log(err,'err');
    })
  },
  //获取易价通一级分类
  getDepart(){
    var that = this
    departTable()
    .then(res=>{
      console.log(res,'res');
      if(res.message.status == 'success'){
        that.departArr = res.data
      }else{
        that.$message.error(err,'err')
      }
    })
    .catch(err=>{
      console.log(err,'err');
    })
  },
  departChange(e){
    console.log(e,'eeeee');
    var that = this
    that.dialogForm.category_name = []
    that.departArr.forEach(item=>{
      e.forEach(ele=>{
        if(item.id == ele){
          that.dialogForm.category_name.push(item.name)
        }
      })
    })
    console.log(that.dialogForm,'formform');
  },
  categoryChange(e){
    var that = this
    console.log(e,'222222222');
    this.roleArr.forEach(item=>{
      if(item.id == e){
        that.dialogForm.role_name = item.name
      }
    })
  },
  //新增工单分配
  dialogCommit(){
    var that = this
    var params = {
      role_id:that.dialogForm.role_id,
      role_name:that.dialogForm.role_name,
      category_id:JSON.stringify(that.dialogForm.category_id),
      category_name:JSON.stringify(that.dialogForm.category_name)
    }
    conversionInsert(params)
    .then(res=>{
      console.log(res,'res');
      if(res.message.status == 'success'){
        that.$message.success(res.message.text);
        that.getconversionTable()
        that.dialogFormVisible = false
        that.$message.success('成功')
      }else{
        that.$message.error('失败')
      }
    })
    .catch(err=>{
      console.log(err,'err');
    })
  }
},
created() {},
mounted() {},
activated(){
  this.getconversionTable();
  this.getRoleTable()
  this.getDepart()
}
};
</script>
<style lang="scss" scoped>
.roleManage{
 .clearfix{
    display: flex;
    justify-content: space-between;
    align-items: center;
 }
 .pages{
  text-align: right;
  margin-top: 20px;
 }
}
</style>